<script>
import { hasOtherSelection, normalizeSelectionList } from './selection_helpers'

export default {
  props: {

    initialOwnProducts: {
      type: [Boolean, String], // Aceita string se o Rails injetar como texto
      default: false
    },
    casesOptions: {
      type: Array,
      default: () => []
    },
    productsOptions: {
      type: Array,
      default: () => []
    },
    marketSegmentOptions: {
      type: Array,
      default: () => []
    },
    selectedFundingSources: {
      type: [Array, String],
      default: () => []
    },
    selectedFundingNatures: {
      type: [Array, String],
      default: () => []
    },
    selectedFundingDifficulties: {
      type: [Array, String],
      default: () => []
    },
    selectedUniversityPartnerships: {
      type: [Array, String],
      default: () => []
    },
    selectedStrategicActions: {
      type: [Array, String],
      default: () => []
    },
    selectedCapitalShortageLanguages: {
      type: [Array, String],
      default: () => []
    },
    selectedInternalTechnologies: {
      type: [Array, String],
      default: () => []
    },
    selectedProgrammingLanguages: {
      type: [Array, String],
      default: () => []
    },
    selectedPlatformStacks: {
      type: [Array, String],
      default: () => []
    },
    selectedOrganizationalCertifications: {
      type: [Array, String],
      default: () => []
    },
    initialOrganizationalCertificationsOther: {
      type: String,
      default: ''
    },
    selectedDesiredTechnologies: {
      type: [Array, String],
      default: () => []
    },
    selectedGrowthChallenges: {
      type: [Array, String],
      default: () => []
    },
    selectedPerceivedRisks: {
      type: [Array, String],
      default: () => []
    },
    selectedMaScenarios: {
      type: [Array, String],
      default: () => []
    },
    selectedApontiHelpTopics: {
      type: [Array, String],
      default: () => []
    },
    selectedPartnershipUniversitiesNames: {
      type: [Array, String],
      default: () => []
    },
    selectedPartnershipIctsNames: {
      type: [Array, String],
      default: () => []
    },
    associatedCompanyOptions: {
      type: Array,
      default: () => []
    },
    selectedAssociatedCompanySuppliers: {
      type: [Array, String],
      default: () => []
    },
    selectedAssociatedCompanyClients: {
      type: [Array, String],
      default: () => []
    },
    selectedPartnershipBigPlayersNames: {
      type: [Array, String],
      default: () => []
    },
    selectedPartnershipInternationalInstitutionNames: {
      type: [Array, String],
      default: () => []
    },
    initialPartnershipInternationalInstitutionOther: {
      type: String,
      default: ''
    },
    selectedEcosystemCommunities: {
      type: [Array, String],
      default: () => []
    },
    selectedTechnicalCompetencies: {
      type: [Array, String],
      default: () => []
    },
    initialPartnershipUniversities: {
      type: [Boolean, String],
      default: false
    },
    initialPartnershipIcts: {
      type: [Boolean, String],
      default: false
    },
    initialPartnershipAssociatedCompanies: {
      type: [Boolean, String],
      default: false
    },
    initialPartnershipBigPlayers: {
      type: [Boolean, String],
      default: false
    },
    initialPartnershipInternationalInstitutions: {
      type: [Boolean, String],
      default: false
    },
    initialAssociatedCompanyRelationshipType: {
      type: String,
      default: ''
    },
    initialSectorAssociations: {
      type: [Boolean, String],
      default: false
    },
    initialSectorAssociationsNames: {
      type: String,
      default: ''
    },
    initialCompanyDataLake: {
      type: [Boolean, String],
      default: null
    },
    initialCompanyDataGovernance: {
      type: [Boolean, String],
      default: null
    },
    initialCompanyIaBudget: {
      type: String,
      default: ''
    },
    initialCompanyIaInvestments: {
      type: [Array, String],
      default: () => []
    },
    initialCurrentSubTab: {
      type: String,
      default: 'products'
    }
  },

  data() {
    return {
      openModalDropdown: null,
      activeTechnicalLevelOption: null,
      tooltipInstances: [],
      // Normaliza para booleano real logo na entrada
      ownProducts: this.initialOwnProducts === true || this.initialOwnProducts === 'true',
      companyCases: (this.casesOptions || []).map((projectCase) => this.normalizeCase(projectCase)),
      removedCases: [],
      newCase: this.blankCase(),
      editingCaseIndex: null,
      productLimit: 5,
      companyProducts: (this.productsOptions || []).map((product) => this.normalizeProduct(product)),
      removedProducts: [],
      newProduct: this.blankProduct(),
      editingProductIndex: null,
      maxProductMarketSegments: 5,
      hydratingProductForm: false,
      technicalCompetencies: this.normalizeTechnicalCompetencies(this.selectedTechnicalCompetencies),
      internalTechnologies: this.normalizeTechnicalCompetencies(this.selectedInternalTechnologies),
      programmingLanguages: this.normalizeTechnicalCompetencies(this.selectedProgrammingLanguages),
      technicalCompetencyOther: '',
      internalTechnologyOther: '',
      programmingLanguageOther: '',
      platformStacks: normalizeSelectionList(this.selectedPlatformStacks),
      organizationalCertifications: normalizeSelectionList(this.selectedOrganizationalCertifications),
      organizationalCertificationOther: this.initialOrganizationalCertificationsOther || '',
      technicalOtherErrors: {},
      productValidationErrors: {},
      company: {
        has_data_lake: this.normalizeBoolean(this.initialCompanyDataLake),
        has_data_governance: this.normalizeBoolean(this.initialCompanyDataGovernance),
        ia_budget: this.initialCompanyIaBudget || '',
        ia_investments: normalizeSelectionList(this.initialCompanyIaInvestments)
      },
      formalPartnerships: {
        universities: this.normalizeBoolean(this.initialPartnershipUniversities),
        icts: this.normalizeBoolean(this.initialPartnershipIcts),
        associatedCompanies: this.normalizeBoolean(this.initialPartnershipAssociatedCompanies),
        bigPlayers: this.normalizeBoolean(this.initialPartnershipBigPlayers),
        internationalInstitutions: this.normalizeBoolean(this.initialPartnershipInternationalInstitutions)
      },
      associatedCompanyRelationshipType: this.initialAssociatedCompanyRelationshipType || '',
      partnershipInternationalInstitutionOther: this.initialPartnershipInternationalInstitutionOther || '',
      sectorAssociations: this.normalizeBoolean(this.initialSectorAssociations),
      sectorAssociationsNames: this.initialSectorAssociationsNames || '',
      universityPartnershipInput: '',
      universityPartnershipSuggestionsOpen: false,
      partnershipUniversitiesInput: '',
      partnershipUniversitiesSuggestionsOpen: false,
      partnershipIctsInput: '',
      partnershipIctsSuggestionsOpen: false,
      partnershipBigPlayersInput: '',
      innovation: {
        funding_sources: normalizeSelectionList(this.selectedFundingSources),
        funding_nature: normalizeSelectionList(this.selectedFundingNatures),
        funding_difficulties: normalizeSelectionList(this.selectedFundingDifficulties),
        university_partnerships: normalizeSelectionList(this.selectedUniversityPartnerships),
        strategic_actions: normalizeSelectionList(this.selectedStrategicActions),
        capital_shortage_languages: normalizeSelectionList(this.selectedCapitalShortageLanguages),
        desired_technologies: normalizeSelectionList(this.selectedDesiredTechnologies),
        growth_challenges: normalizeSelectionList(this.selectedGrowthChallenges),
        perceived_risks: normalizeSelectionList(this.selectedPerceivedRisks),
        ma_scenarios: normalizeSelectionList(this.selectedMaScenarios),
        aponti_help_topics: normalizeSelectionList(this.selectedApontiHelpTopics),
        partnership_universities_names: normalizeSelectionList(this.selectedPartnershipUniversitiesNames),
        partnership_icts_names: normalizeSelectionList(this.selectedPartnershipIctsNames),
        associated_company_suppliers: normalizeSelectionList(this.selectedAssociatedCompanySuppliers),
        associated_company_clients: normalizeSelectionList(this.selectedAssociatedCompanyClients),
        partnership_big_players_names: normalizeSelectionList(this.selectedPartnershipBigPlayersNames),
        partnership_international_institution_names: normalizeSelectionList(this.selectedPartnershipInternationalInstitutionNames),
        ecosystem_communities: normalizeSelectionList(this.selectedEcosystemCommunities)
      },
      innovationFundingSourceOptions: [
        { value: 'finep', text: 'FINEP' },
        { value: 'bndes', text: 'BNDES' },
        { value: 'fap', text: 'FAP´s (Ex: FACEPE, FAPESP, etc.)' },
        { value: 'embrapii', text: 'Embrapii' },
        { value: 'editais_chamadas_internacionais', text: 'Editais/Chamadas internacionais' },
        { value: 'lei_inovacao_estadual', text: 'Lei de Inovação Estadual (PRODEPE/PRODIMPE/PRODEAUTO)' },
        { value: 'lei_do_bem', text: 'Lei do Bem' },
        { value: 'investimento_privado', text: 'Investimento Privado (anjo, seed, VC, equity), M&A' },
        { value: 'sebrae', text: 'Sebrae' },
        { value: 'senai', text: 'SENAI' },
        { value: 'abdi', text: 'ABDI' },
        { value: 'nunca_captou', text: 'Nunca Captou' }
      ],
      fundingNatureOptions: [
        { value: 'reimbursable', text: 'Reembolsável (linhas de financiamento)' },
        { value: 'non_reimbursable', text: 'Não Reembolsável (subvenção, com ou sem contrapartida)' }
      ],
      innovationDifficultyOptions: [
        { value: 'desconhecimento_chamadas_publicas', text: 'Desconhecimento das Chamadas Públicas' },
        { value: 'complexidade_editais', text: 'Complexidade dos Editais' },
        { value: 'falta_equipe', text: 'Falta de Equipe (não temos braço)' },
        { value: 'inexperiencia_propostas', text: 'Inexperiência na Elaboração de Propostas' },
        { value: 'falta_parceiros_qualificados', text: 'Falta de Parceiros Qualificados' },
        { value: 'nao_qualificacao_proponente', text: 'Não Qualificação como Proponente' },
        { value: 'outros', text: 'Outros' }
      ],
      universityPartnershipOptions: [
        { value: 'ufpe', text: 'Universidade Federal de Pernambuco (UFPE)' },
        { value: 'sebrae', text: 'SEBRAE' },
        { value: 'unifesp', text: 'Universidade Federal de São Paulo (UNIFESP)' },
        { value: 'ufrj', text: 'Universidade Federal do Rio de Janeiro (UFRJ)' },
        { value: 'ufmg', text: 'Universidade Federal de Minas Gerais (UFMG)' },
        { value: 'ufpr', text: 'Universidade Federal do Paraná (UFPR)' },
        { value: 'ufsc', text: 'Universidade Federal de Santa Catarina (UFSC)' },
        { value: 'ufba', text: 'Universidade Federal da Bahia (UFBA)' },
        { value: 'ufc', text: 'Universidade Federal do Ceará (UFC)' },
        { value: 'ufrgs', text: 'Universidade Federal do Rio Grande do Sul (UFRGS)' },
        { value: 'ufg', text: 'Universidade Federal de Goiás (UFG)' },
        { value: 'ufal', text: 'Universidade Federal de Alagoas (UFAL)' },
        { value: 'ufma', text: 'Universidade Federal do Maranhão (UFMA)' },
        { value: 'ufsj', text: 'Universidade Federal de São João del-Rei (UFSJ)' },
        { value: 'ufla', text: 'Universidade Federal de Lavras (UFLA)' },
        { value: 'ufs', text: 'Universidade Federal de Sergipe (UFS)' },
        { value: 'ufes', text: 'Universidade Federal do Espírito Santo (UFES)' },
        { value: 'ufms', text: 'Universidade Federal de Mato Grosso do Sul (UFMS)' }
      ],
      strategicActionOptions: [
        { value: 'consolidar_produto', text: 'Consolidar produto ou serviço atual ou desenvolver novos produtos e serviços.' },
        { value: 'atrair_investidores', text: 'Atrair investidores para impulsionar o crescimento.' },
        { value: 'expandir_mercado', text: 'Expandir para novos mercados, como o Sul, Sudeste ou até mesmo internacionalização.' },
        { value: 'fortalecer_vendas', text: 'Fortalecer a força de vendas para aumentar a presença no mercado.' },
        { value: 'fortalecer_equipe', text: 'Fortalecer a equipe técnica para garantir inovação contínua.' }
      ],
      languageOptions: [
        { value: 'python', text: 'Python' },
        { value: 'solidity', text: 'Solidity' },
        { value: 'haskell', text: 'Haskell' },
        { value: 'javascript', text: 'JavaScript' },
        { value: 'swift', text: 'Swift' },
        { value: 'edge_computing', text: 'Edge Computing' },
        { value: 'machine_learning', text: 'Machine Learning' },
        { value: 'cybersecurity', text: 'Cybersecurity' },
        { value: 'rust', text: 'Rust' },
        { value: 'ruby', text: 'Ruby' },
        { value: 'outros', text: 'Outras' }
      ],
      technologyOptions: [
        { value: 'artificial_intelligence', text: 'Inteligência Artificial' },
        { value: 'data_science', text: 'Ciência de Dados' },
        { value: 'cloud_computing', text: 'Cloud Computing' },
        { value: 'cybersecurity', text: 'Cibersegurança' },
        { value: 'computer_vision', text: 'Visão Computacional' },
        { value: 'iot', text: 'IoT' },
        { value: 'blockchain', text: 'Blockchain' },
        { value: 'web_systems', text: 'Sistemas Web' },
        { value: 'mobile', text: 'Mobile' },
        { value: 'devops', text: 'DevOps' },
        { value: 'embedded_systems', text: 'Sistemas embarcados' },
        { value: 'rpa', text: 'RPA' },
        { value: 'low_code_no_code', text: 'Low-code/No-code' },
        { value: 'ar_vr', text: 'AR/VR' },
        { value: 'edge_computing', text: 'Edge Computing' },
        { value: 'five_g_connectivity', text: '5G/conectividade' },
        { value: 'robotics', text: 'Robótica' },
        { value: 'quantum', text: 'Quantum' },
        { value: 'data_engineering', text: 'Engenharia de Dados' },
        { value: 'mlops', text: 'MLOps' },
        { value: 'other', text: 'Outras' }
      ],
      growthChallengeOptions: [
        { value: 'financeiro', text: 'Financeiro', description: 'Ex: capital para investir em novos produtos/serviços, custos fixos altos, ...' },
        { value: 'tecnico', text: 'Técnico', description: 'Ex: expertise da equipe, rotatividade das pessoas, ...' },
        { value: 'comercial', text: 'Comercial', description: 'Ex: ciclo de venda longo, venda muito complexa (consultiva), taxa de conversão baixa, ...' },
        { value: 'marketing', text: 'Marketing', description: 'Ex: posicionamento, produto/serviço obsoleto, falta de visibilidade nos mercados alvo, ...' },
        { value: 'modelo_negocio', text: 'Modelo de Negócio', description: 'Ex: pouca receita recorrente, dificuldades de escalar produto, ...' },
        { value: 'outro', text: 'Outro', description: 'Especifique' }
      ],
      perceivedRiskOptions: [
        { value: 'regulatorios', text: 'Regulatórios' },
        { value: 'cambiais', text: 'Cambiais' },
        { value: 'competicao_internacional', text: 'Competição internacional' },
        { value: 'ia_substituindo_produtos_servicos', text: 'IA substituindo produtos/serviços' },
        { value: 'perda_cliente_ancora', text: 'Perda de cliente-âncora' },
        { value: 'escassez_talentos', text: 'Escassez de talentos' }
      ],
      maScenarioOptions: [
        { value: 'ser_adquirida', text: 'Ser adquirida' },
        { value: 'adquirir', text: 'Adquirir' },
        { value: 'fusao', text: 'Em fusão' }
      ],
      apontiHelpOptions: [
        { value: 'captacao_de_recursos', text: 'Captação de recursos para desenvolvimento de projetos' },
        { value: 'acesso_a_grandes_clientes', text: 'Acesso a grandes clientes' },
        { value: 'acesso_a_investidores', text: 'Acesso a investidores' },
        { value: 'ampliar_parcerias', text: 'Ampliar parcerias entre associadas' },
        { value: 'capacitacao', text: 'Capacitação' },
        { value: 'fornecimento_de_capital_humano', text: 'Fornecimento de capital humano' },
        { value: 'internacionalizacao', text: 'Internacionalização' },
        { value: 'conexao_com_governo', text: 'Conexão com governo' },
        { value: 'inteligencia_de_mercado', text: 'Inteligência de mercado' },
        { value: 'benchmarkings', text: 'Benchmarkings' },
        { value: 'suporte_juridico_regulatorio', text: 'Suporte jurídico-regulatório' },
        { value: 'agenda_de_eventos', text: 'Agenda de eventos' },
        { value: 'outros', text: 'Outros' }
      ],
      shortUniversityOptions: [
        { value: 'ufpe', text: 'Universidade Federal de Pernambuco (UFPE)' },
        { value: 'sebrae', text: 'SEBRAE' },
        { value: 'unifesp', text: 'Universidade Federal de São Paulo (UNIFESP)' },
        { value: 'ufrj', text: 'Universidade Federal do Rio de Janeiro (UFRJ)' },
        { value: 'ufmg', text: 'Universidade Federal de Minas Gerais (UFMG)' },
        { value: 'ufpr', text: 'Universidade Federal do Paraná (UFPR)' },
        { value: 'ufsc', text: 'Universidade Federal de Santa Catarina (UFSC)' },
        { value: 'ufba', text: 'Universidade Federal da Bahia (UFBA)' },
        { value: 'ufc', text: 'Universidade Federal do Ceará (UFC)' },
        { value: 'ufrgs', text: 'Universidade Federal do Rio Grande do Sul (UFRGS)' },
        { value: 'ufg', text: 'Universidade Federal de Goiás (UFG)' },
        { value: 'ufal', text: 'Universidade Federal de Alagoas (UFAL)' },
        { value: 'ufma', text: 'Universidade Federal do Maranhão (UFMA)' },
        { value: 'ufsj', text: 'Universidade Federal de São João del-Rei (UFSJ)' },
        { value: 'ufla', text: 'Universidade Federal de Lavras (UFLA)' },
        { value: 'ufs', text: 'Universidade Federal de Sergipe (UFS)' },
        { value: 'ufes', text: 'Universidade Federal do Espírito Santo (UFES)' },
        { value: 'ufms', text: 'Universidade Federal de Mato Grosso do Sul (UFMS)' }
      ],
      ictOptions: [
        { value: 'sebrae', text: 'Sebrae' },
        { value: 'senai', text: 'Senai' },
        { value: 'softex', text: 'Softex' },
        { value: 'cesar', text: 'Cesar' },
        { value: 'porto_digital', text: 'Porto Digital' }
      ],
      bigPlayerOptions: [
        { value: 'totvs', text: 'TOTVS' },
        { value: 'nubank', text: 'Nubank' },
        { value: 'ifood', text: 'IFood' },
        { value: 'vtex', text: 'VTEX' },
        { value: 'stefanini', text: 'Stefanini' },
        { value: 'ci_and_t', text: 'CI&T' },
        { value: 'locaweb', text: 'Locaweb' },
        { value: 'stone', text: 'Stone' },
        { value: 'pagbank', text: 'PagBank' },
        { value: 'senior_sistemas', text: 'Senior Sistemas' },
        { value: 'outros', text: 'Outros' }
      ],
      internationalInstitutionOptions: [
       { value: 'microsoft', text: 'Microsoft' },
        { value: 'apple', text: 'Apple' },
        { value: 'nvidia', text: 'NVIDIA' },
        { value: 'alphabet', text: 'Alphabet (Google)' },
        { value: 'amazon', text: 'Amazon' },
        { value: 'meta', text: 'Meta (Facebook)' },
        { value: 'tesla', text: 'Tesla' },
        { value: 'tencent', text: 'Tencent' },
        { value: 'alibaba', text: 'Alibaba' },
        { value: 'tsmc', text: 'TSMC' },
        { value: 'openai', text: 'OpenAi' },
        { value: 'anthropic', text: 'Anthropic' },
        { value: 'outros', text: 'Outras' }
      ],
      ecosystemCommunityOptions: [
        { value: 'manguez_al', text: 'Manguez.al (Mangue.tech)' },
        { value: 'Cesar_dates', text: 'CESAR Dates' },
        { value: 'porto_digital_startups', text: 'Porto Digital Startups' },
        { value: 'sebrae_startups_pe', text: 'Sebrae Startups PE' },
        { value: 'anjos_do_brasil_pe', text: 'Anjos do Brasil (Núcleo PE)' },
        { value: 'armazem_da_criatividade', text: 'Armazém da Criatividade' },
        { value: 'loop_empreendedorismo', text: 'L.O.O.P. (Liga de Empreendedorismo)' },    
        { value: 'outras', text: 'Outras' }
      ],
      technicalCompetencyOptions: [
        { value: 'artificial_intelligence', text: 'Inteligência Artificial' },
        { value: 'data_science', text: 'Ciência de Dados' },
        { value: 'cloud_computing', text: 'Cloud Computing' },
        { value: 'cybersecurity', text: 'Cibersegurança' },
        { value: 'computer_vision', text: 'Visão Computacional' },
        { value: 'iot', text: 'IoT' },
        { value: 'blockchain', text: 'Blockchain' },
        { value: 'web_systems', text: 'Sistemas Web' },
        { value: 'mobile', text: 'Mobile' },
        { value: 'devops', text: 'DevOps' },
        { value: 'embedded_systems', text: 'Sistemas embarcados' },
        { value: 'rpa', text: 'RPA' },
        { value: 'low_code_no_code', text: 'Low-code/No-code' },
        { value: 'ar_vr', text: 'AR/VR' },
        { value: 'edge_computing', text: 'Edge Computing' },
        { value: 'five_g_connectivity', text: '5G/conectividade' },
        { value: 'robotics', text: 'Robótica' },
        { value: 'quantum', text: 'Quantum' },
        { value: 'data_engineering', text: 'Engenharia de Dados' },
        { value: 'mlops', text: 'MLOps' },
        { value: 'other', text: 'Outros' }
      ],
      technicalCompetencyLevels: [
        { value: 'basic', text: 'Básico' },
        { value: 'intermediate', text: 'Intermediário' },
        { value: 'advanced', text: 'Avançado' }
      ],
      programmingLanguageOptions: [
        { value: 'python', text: 'Python' },
        { value: 'java', text: 'Java' },
        { value: 'javascript', text: 'JavaScript' },
        { value: 'typescript', text: 'TypeScript' },
        { value: 'c_cpp', text: 'C/C++' },
        { value: 'csharp', text: 'C#' },
        { value: 'go', text: 'Go (Golang)' },
        { value: 'rust', text: 'Rust' },
        { value: 'kotlin', text: 'Kotlin' },
        { value: 'swift', text: 'Swift' },
        { value: 'ruby', text: 'Ruby' },
        { value: 'other', text: 'Outras' }
      ],
      platformStackOptions: [
        { value: 'aws', text: 'AWS' },
        { value: 'azure', text: 'Azure' },
        { value: 'gcp', text: 'GCP' },
        { value: 'salesforce', text: 'Salesforce' },
        { value: 'sap', text: 'SAP' },
        { value: 'servicenow', text: 'ServiceNow' }
      ],
      organizationalCertificationOptions: [
        { value: 'iso_27001', text: 'ISO 27001' },
        { value: 'mps_br', text: 'MPS.BR' },
        { value: 'mpt_br', text: 'MPT.BR' },
        { value: 'cmmi', text: 'CMMI' },
        { value: 'lgpd_gdpr', text: 'LGPD/GDPR' },
        { value: 'other', text: 'Outras' }
      ],
      iaTypeOptions: [
        { value: 'preditiva', text: 'Preditiva' },
        { value: 'generativa', text: 'Generativa' },
        { value: 'visao', text: 'Visão' },
        { value: 'nlp', text: 'NLP' },
        { value: 'recomendacao', text: 'Recomendação' }
      ],
      iaComplianceOptions: [
        { value: 'lgpd_aplicada_treinamento', text: 'LGPD Aplicada a Treinamento' },
        { value: 'posicionamento_marco_legal_ia', text: 'Posicionamento Sobre Marco Legal da IA' }
      ],
      iaModelOptions: [
        { value: 'proprio', text: 'Modelo próprio' },
        { value: 'terceiros', text: 'Modelo de terceiros' }
      ],
      iaProviderOptions: [
        { value: 'openai', text: 'OpenAI' },
        { value: 'anthropic', text: 'Anthropic' },
        { value: 'google', text: 'Google' },
        { value: 'outros', text: 'Outros' }
      ],
      iaBudgetOptions: [
        { value: 'ate_100_mil', text: 'Até R$100 mil' },
        { value: '100_mil_a_500_mil', text: 'De R$100 mil a R$500 mil' },
        { value: '500_mil_a_1_milhao', text: 'De R$500 mil a R$1 milhão' },
        { value: '1_milhao_a_2_milhoes', text: 'De R$1 milhão a R$2 milhão' },
        { value: 'mais_de_2_milhoes', text: 'Mais de R$2 milhões' },
        { value: 'nao_tenho_orcamento', text: 'Não tenho orçamento' },
        { value: 'nao_sei_informar', text: 'Não sei informar' }
      ],
      iaInvestmentOptions: [
        { value: 'nao_necessita', text: 'Não necessito de investimento' },
        { value: 'ate_100k', text: 'Até R$100 mil' },
        { value: '100k_500k', text: 'De R$100 mil a R$500 mil' },
        { value: '500k_1m', text: 'De R$500 mil a R$1 milhão' },
        { value: '1m_2m', text: 'De R$1 milhão a R$2 milhão' },
        { value: 'mais_2m', text: 'Mais de R$2 milhões' },
        { value: 'nao_sei_informar', text: 'Não sei informar' }
      ],
      iaInfraOptions: [
        { value: 'internas', text: 'Internas (temos nossos próprios recursos computacionais)' },
        { value: 'externo', text: 'Externo (contratamos de fornecedores)' },
        { value: 'nao_utilizamos', text: 'Não utilizamos' }
      ],
      currentSubTab: this.initialCurrentSubTab || 'technical_competencies',
      verDetalhesTRL: false,
    };
  },

  created() {
    Object.keys(this.formalPartnerships).forEach((partnershipType) => {
      this.handleFormalPartnershipChange(partnershipType, this.formalPartnerships[partnershipType])
    })
  },

  mounted() {
    this.initTooltips()
    document.addEventListener('click', this.closeDropdownsOnOutsideClick)
  },

  updated() {
    this.initTooltips()
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdownsOnOutsideClick)
    this.destroyTooltips()
  },

  computed: {
    showOwnProducts() {
      return this.ownProducts === true || this.ownProducts === 'true';
    },
    productsForForm() {
      return [...this.companyProducts, ...this.removedProducts]
    },
    casesForForm() {
      return [...this.companyCases, ...this.removedCases]
    },
    technicalCompetenciesForForm() {
      return this.technicalCompetencies.filter((competency) => {
        return competency.level || competency.other
      })
    },
    technicalCompetenciesPayload() {
      return JSON.stringify(this.technicalCompetenciesForForm)
    },
    internalTechnologiesForForm() {
      return this.internalTechnologies.filter((technology) => {
        return technology.level || technology.other
      })
    },
    internalTechnologiesPayload() {
      return JSON.stringify(this.internalTechnologiesForForm)
    },
    programmingLanguagesForForm() {
      return this.programmingLanguages.filter((language) => {
        return language.level || language.other
      })
    },
    programmingLanguagesPayload() {
      return JSON.stringify(this.programmingLanguagesForForm)
    },
    platformStackSummary() {
      if (!this.platformStacks.length) return 'Você pode selecionar mais 1 opção'

      return this.selectionSummary(this.platformStacks)
    },
    organizationalCertificationSummary() {
      return this.selectionSummary(this.organizationalCertifications)
    },
    caseLimitReached() {
      return this.companyCases.length >= 3
    },
    productLimitReached() {
      return this.companyProducts.length >= this.productLimit
    },
    fundingSourceSummary() {
      return this.selectionSummary(this.innovation.funding_sources)
    },
    fundingNatureSummary() {
      return this.selectionSummary(this.innovation.funding_nature)
    },
    fundingDifficultySummary() {
      return this.selectionSummary(this.innovation.funding_difficulties)
    },
    universityPartnershipSummary() {
      return this.selectionSummary(this.innovation.university_partnerships)
    },
    filteredUniversityPartnershipOptions() {
      const searchText = this.normalizeUniversityPartnershipText(this.universityPartnershipInput)
      if (!searchText) return []

      return this.universityPartnershipOptions.filter((option) => {
        const optionText = this.normalizeUniversityPartnershipText(option.text)
        const alreadySelected = this.innovation.university_partnerships.some((partnership) => {
          return this.normalizeUniversityPartnershipText(this.universityPartnershipText(partnership)) === optionText
        })

        return optionText.includes(searchText) && !alreadySelected
      })
    },
    showUniversityPartnershipSuggestions() {
      return this.universityPartnershipSuggestionsOpen && this.filteredUniversityPartnershipOptions.length > 0
    },
    filteredPartnershipUniversitiesOptions() {
      return this.filteredTypedPartnershipOptions(
        this.partnershipUniversitiesInput,
        this.shortUniversityOptions,
        'partnership_universities_names'
      )
    },
    showPartnershipUniversitiesSuggestions() {
      return this.partnershipUniversitiesSuggestionsOpen && this.filteredPartnershipUniversitiesOptions.length > 0
    },
    filteredPartnershipIctsOptions() {
      return this.filteredTypedPartnershipOptions(
        this.partnershipIctsInput,
        this.ictOptions,
        'partnership_icts_names'
      )
    },
    showPartnershipIctsSuggestions() {
      return this.partnershipIctsSuggestionsOpen && this.filteredPartnershipIctsOptions.length > 0
    },
    strategicActionSummary() {
      return this.selectionSummary(this.innovation.strategic_actions)
    },
    capitalShortageLanguageSummary() {
      return this.selectionSummary(this.innovation.capital_shortage_languages)
    },
    showCapitalShortageLanguagesOther() {
      return hasOtherSelection(this.innovation.capital_shortage_languages)
    },
    desiredTechnologySummary() {
      return this.selectionSummary(this.innovation.desired_technologies)
    },
    growthChallengeSummary() {
      return this.selectionSummary(this.innovation.growth_challenges)
    },
    perceivedRiskSummary() {
      return this.selectionSummary(this.innovation.perceived_risks)
    },
    maScenarioSummary() {
      return this.selectionSummary(this.innovation.ma_scenarios)
    },
    apontiHelpSummary() {
      return this.selectionSummary(this.innovation.aponti_help_topics)
    },
    partnershipUniversitiesSummary() {
      return this.selectionSummary(this.innovation.partnership_universities_names)
    },
    partnershipIctsSummary() {
      return this.selectionSummary(this.innovation.partnership_icts_names)
    },
    associatedCompanySuppliersSummary() {
      return this.selectionSummary(this.innovation.associated_company_suppliers)
    },
    associatedCompanyClientsSummary() {
      return this.selectionSummary(this.innovation.associated_company_clients)
    },
    showAssociatedCompanySuppliers() {
      return ['fornecedor', 'os_dois'].includes(this.associatedCompanyRelationshipType)
    },
    showAssociatedCompanyClients() {
      return ['cliente', 'os_dois'].includes(this.associatedCompanyRelationshipType)
    },
    partnershipBigPlayersSummary() {
      return this.selectionSummary(this.innovation.partnership_big_players_names)
    },
    partnershipInternationalInstitutionsSummary() {
      return this.selectionSummary(this.innovation.partnership_international_institution_names)
    },
    ecosystemCommunitySummary() {
      return this.selectionSummary(this.innovation.ecosystem_communities)
    },
    iaTypeSummary() {
      const options = this.productArrayField('ia_types')

      return options.length ? `${options.length} selecionados` : 'Selecione...';
    },
    iaComplianceSummary() {
      const options = this.productArrayField('ia_compliances')

      return options.length ? `${options.length} selecionados` : 'Selecione...';
    },
    iaMarketSegmentSummary() {
      const options = this.productArrayField('ia_market_segments')

      if (options.length === 0) return 'Selecione até 5'
      if (options.length === 1) return '1 selecionado'

      return `${options.length} selecionados`
    },
    iaModelSummary() {
      const options = this.productArrayField('ia_models')

      return options.length ? `${options.length} selecionados` : 'Selecione...';
    },
    usesThirdPartyIaModel() {
      return this.productArrayField('ia_models').includes('terceiros')
    },
    hasOtherProductMarketSegment() {
      return this.productArrayField('ia_market_segments').includes('other')
    },
    iaProviderSummary() {
      const options = this.productArrayField('ia_providers')

      return options.length ? `${options.length} selecionados` : 'Selecione...';
    },
    iaInvestmentSelection: {
      get() {
        return this.companyArrayField('ia_investments')[0] || '';
      },
      set(value) {
        this.company.ia_investments = value ? [value] : [];
      }
    },
    iaInfraSummary() {
      const options = this.productArrayField('ia_infras')

      return options.length ? `${options.length} selecionados` : 'Selecione...';
    }
  },

  watch: {
    ownProducts(newValue) {
      if (typeof newValue === 'string') {
        this.ownProducts = newValue === 'true';
      }

      if (newValue === false || newValue === 'false') {
        this.companyProducts.forEach((product) => {
          if (product.id) this.removedProducts.push({ ...product, _destroy: true })
        })
        this.companyProducts = []
      }
    },
    'newProduct.uses_ia'(newValue) {
      if (this.hydratingProductForm) return
      if (!this.isFalsy(newValue)) return

      this.newProduct.ia_problem = ''
      this.newProduct.ia_compliances = []
      this.newProduct.ia_market_segments = []
      this.newProduct.ia_market_segment_other = ''
      this.newProduct.ia_types = []
      this.newProduct.ia_models = []
      this.newProduct.ia_providers = []
      this.newProduct.ia_provider_other = ''
      this.newProduct.ia_budget = ''
      this.newProduct.has_data_lake = null
      this.newProduct.has_data_governance = null
      this.newProduct.ia_investments = []
      this.newProduct.ia_infras = []
      this.openModalDropdown = null
      const iaFieldErrors = [
        'ia_problem',
        'ia_compliances',
        'ia_market_segments',
        'ia_market_segment_other',
        'ia_types',
        'ia_models',
        'ia_providers',
        'ia_provider_other',
        'has_data_lake',
        'has_data_governance',
        'ia_budget',
        'ia_investments',
        'ia_infras'
      ]
      iaFieldErrors.forEach((fieldName) => this.clearProductValidationError(fieldName))
    },
    'newProduct.ia_models'(newValue) {
      if (this.hydratingProductForm) return
      this.clearIaProviderFieldsWhenThirdPartyModelIsNotSelected(newValue)
    },
    'newProduct.has_intellectual_property'(newValue) {
      if (this.hydratingProductForm) return
      if (!this.isFalsy(newValue)) return

      this.newProduct.qty_patents = ''
      this.newProduct.qty_trademarks = ''
      this.newProduct.qty_software_registrations = ''
      const intellectualPropertyFieldErrors = [
        'qty_patents',
        'qty_trademarks',
        'qty_software_registrations'
      ]
      intellectualPropertyFieldErrors.forEach((fieldName) => this.clearProductValidationError(fieldName))
    },
    'formalPartnerships.universities'(newValue) {
      this.handleFormalPartnershipChange('universities', newValue)
    },
    'formalPartnerships.icts'(newValue) {
      this.handleFormalPartnershipChange('icts', newValue)
    },
    'formalPartnerships.associatedCompanies'(newValue) {
      this.handleFormalPartnershipChange('associatedCompanies', newValue)
    },
    'formalPartnerships.bigPlayers'(newValue) {
      this.handleFormalPartnershipChange('bigPlayers', newValue)
    },
    'formalPartnerships.internationalInstitutions'(newValue) {
      this.handleFormalPartnershipChange('internationalInstitutions', newValue)
    },
    associatedCompanyRelationshipType() {
      if (!this.showAssociatedCompanySuppliers) {
        this.innovation.associated_company_suppliers = []
        if (this.openModalDropdown === 'associatedSuppliers') this.openModalDropdown = null
      }

      if (!this.showAssociatedCompanyClients) {
        this.innovation.associated_company_clients = []
        if (this.openModalDropdown === 'associatedClients') this.openModalDropdown = null
      }
    },
    sectorAssociations(newValue) {
      if (typeof newValue === 'string') {
        this.sectorAssociations = this.normalizeBoolean(newValue)
      }

      if (this.isFalsy(newValue)) {
        this.sectorAssociationsNames = ''
      }
    },
    organizationalCertificationOther(newValue) {
      if (newValue && String(newValue).trim()) {
        this.clearTechnicalOtherError('organizational_certifications_other')
      }
    }
  },

  methods: {
    initTooltips() {
      this.destroyTooltips()
      if (!window.bootstrap || !window.bootstrap.Tooltip) return

      const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
      this.tooltipInstances = [...tooltipTriggerList].map((tooltipTriggerEl) => {
        return window.bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl)
      })
    },
    destroyTooltips() {
      if (!this.tooltipInstances.length) return

      this.tooltipInstances.forEach((tooltip) => tooltip.dispose())
      this.tooltipInstances = []
    },
    normalizeBoolean(value) {
      return value === true || value === 'true'
    },
    normalizeNullableBoolean(value) {
      if (value === true || value === 'true') return true
      if (value === false || value === 'false') return false

      return null
    },
    isTruthy(value) {
      return value === true || value === 'true'
    },
    isFalsy(value) {
      return value === false || value === 'false'
    },
    isBlank(value) {
      return value === null || value === undefined || String(value).trim() === ''
    },
    normalizeSelectionList(value) {
      return normalizeSelectionList(value)
    },
    hasOtherSelection(value) {
      return hasOtherSelection(value)
    },
    hasProductValidationError(fieldName) {
      return Boolean(this.productValidationErrors[fieldName])
    },
    clearProductValidationError(fieldName) {
      this.$delete(this.productValidationErrors, fieldName)
    },
    validateProductForm() {
      const errors = {}

      if (this.isBlank(this.newProduct.name)) errors.name = 'Informe o nome do produto/serviço.'
      if (this.isBlank(this.newProduct.description)) errors.description = 'Informe a descrição.'
      if (this.isBlank(this.newProduct.trl)) errors.trl = 'Selecione o nível de maturidade tecnológica.'
      if (this.newProduct.uses_ia === null || this.newProduct.uses_ia === undefined || this.newProduct.uses_ia === '') {
        errors.uses_ia = 'Informe se o produto/serviço utiliza IA.'
      }

      if (this.isTruthy(this.newProduct.uses_ia)) {
        if (this.isBlank(this.newProduct.ia_problem)) errors.ia_problem = 'Informe qual problema a IA resolve.'
        if (!this.productArrayField('ia_market_segments').length) errors.ia_market_segments = 'Selecione pelo menos um mercado alvo.'
        if (this.hasOtherProductMarketSegment && this.isBlank(this.newProduct.ia_market_segment_other)) {
          errors.ia_market_segment_other = 'Informe qual é o outro segmento de mercado.'
        }
        if (!this.productArrayField('ia_types').length) errors.ia_types = 'Selecione pelo menos um tipo de IA.'
        if (!this.productArrayField('ia_models').length) errors.ia_models = 'Selecione pelo menos um modelo de IA.'
        if (this.usesThirdPartyIaModel && !this.productArrayField('ia_providers').length) {
          errors.ia_providers = 'Selecione pelo menos um modelo.'
        }
        if (this.usesThirdPartyIaModel && this.productArrayField('ia_providers').includes('outros') && this.isBlank(this.newProduct.ia_provider_other)) {
          errors.ia_provider_other = 'Informe qual é o outro modelo.'
        }
        if (!this.productArrayField('ia_infras').length) errors.ia_infras = 'Selecione a infraestrutura computacional.'
      }

      if (this.isBlank(this.newProduct.monetization_model)) errors.monetization_model = 'Selecione o modelo de monetização.'
      if (this.isBlank(this.newProduct.active_clients)) errors.active_clients = 'Informe a quantidade de clientes ativos.'
      if (this.newProduct.has_intellectual_property === null || this.newProduct.has_intellectual_property === undefined || this.newProduct.has_intellectual_property === '') {
        errors.has_intellectual_property = 'Informe se existe propriedade intelectual.'
      }

      if (this.isTruthy(this.newProduct.has_intellectual_property)) {
        if (this.isBlank(this.newProduct.qty_patents)) errors.qty_patents = 'Informe a quantidade de patentes.'
        if (this.isBlank(this.newProduct.qty_trademarks)) errors.qty_trademarks = 'Informe a quantidade de marcas.'
        if (this.isBlank(this.newProduct.qty_software_registrations)) errors.qty_software_registrations = 'Informe a quantidade de registros de software.'
      }

      this.productValidationErrors = errors

      if (Object.keys(errors).length) {
        this.openFirstProductValidationError(errors)
        return false
      }

      return true
    },
    openFirstProductValidationError(errors) {
      const dropdownByField = {
        ia_compliances: 'iaCompliance',
        ia_market_segments: 'iaMarketSegment',
        ia_market_segment_other: 'iaMarketSegment',
        ia_types: 'iaType',
        ia_models: 'iaModel',
        ia_providers: 'iaProvider',
        ia_provider_other: 'iaProvider',
        ia_investments: 'iaInvestment',
        ia_infras: 'iaInfra'
      }
      const firstField = Object.keys(errors)[0]
      this.openModalDropdown = dropdownByField[firstField] || null

      this.$nextTick(() => {
        const firstInvalid = this.$el.querySelector('#ownProductsModal .is-invalid')
        if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    normalizeTechnicalCompetencies(value) {
      let competencies = value

      if (typeof value === 'string') {
        try {
          competencies = JSON.parse(value)
        } catch (_error) {
          competencies = []
        }
      }

      if (!Array.isArray(competencies)) return []

      return competencies.map((competency) => {
        if (typeof competency === 'string') {
          return {
            technology: competency,
            level: '',
            other: ''
          }
        }

        return {
          technology: String(competency.technology || ''),
          level: String(competency.level || ''),
          other: String(competency.other || '')
        }
      }).filter((competency) => competency.technology)
    },
    technicalCompetencyLevel(technology) {
      const competency = this.technicalCompetencies.find((item) => item.technology === technology)

      return competency ? competency.level : ''
    },
    setTechnicalCompetencyLevel(technology, level) {
      const competency = this.technicalCompetencies.find((item) => item.technology === technology)

      if (competency) {
        competency.level = level
        return
      }

      this.technicalCompetencies.push({ technology, level, other: '' })
    },
    clearTechnicalCompetencyLevel(technology) {
      const competency = this.technicalCompetencies.find((item) => item.technology === technology)
      if (!competency) return

      competency.level = ''

      if (!competency.other) {
        this.technicalCompetencies = this.technicalCompetencies.filter((item) => item.technology !== technology)
      }
    },
    toggleTechnicalCompetencyLevel(technology, level, event) {
      if (this.technicalCompetencyLevel(technology) === level) {
        event.preventDefault()
        this.clearTechnicalCompetencyLevel(technology)
        return
      }

      this.setTechnicalCompetencyLevel(technology, level)
    },
    internalTechnologyLevel(technology) {
      const internalTechnology = this.internalTechnologies.find((item) => item.technology === technology)

      return internalTechnology ? internalTechnology.level : ''
    },
    setInternalTechnologyLevel(technology, level) {
      const internalTechnology = this.internalTechnologies.find((item) => item.technology === technology)

      if (internalTechnology) {
        internalTechnology.level = level
        return
      }

      this.internalTechnologies.push({ technology, level, other: '' })
    },
    clearInternalTechnologyLevel(technology) {
      const internalTechnology = this.internalTechnologies.find((item) => item.technology === technology)
      if (!internalTechnology) return

      internalTechnology.level = ''

      if (!internalTechnology.other) {
        this.internalTechnologies = this.internalTechnologies.filter((item) => item.technology !== technology)
      }
    },
    toggleInternalTechnologyLevel(technology, level, event) {
      if (this.internalTechnologyLevel(technology) === level) {
        event.preventDefault()
        this.clearInternalTechnologyLevel(technology)
        return
      }

      this.setInternalTechnologyLevel(technology, level)
    },
    programmingLanguageLevel(language) {
      const programmingLanguage = this.programmingLanguages.find((item) => item.technology === language)

      return programmingLanguage ? programmingLanguage.level : ''
    },
    setProgrammingLanguageLevel(language, level) {
      const programmingLanguage = this.programmingLanguages.find((item) => item.technology === language)

      if (programmingLanguage) {
        programmingLanguage.level = level
        return
      }

      this.programmingLanguages.push({ technology: language, level, other: '' })
    },
    clearProgrammingLanguageLevel(language) {
      const programmingLanguage = this.programmingLanguages.find((item) => item.technology === language)
      if (!programmingLanguage) return

      programmingLanguage.level = ''

      if (!programmingLanguage.other) {
        this.programmingLanguages = this.programmingLanguages.filter((item) => item.technology !== language)
      }
    },
    toggleProgrammingLanguageLevel(language, level, event) {
      if (this.programmingLanguageLevel(language) === level) {
        event.preventDefault()
        this.clearProgrammingLanguageLevel(language)
        return
      }

      this.setProgrammingLanguageLevel(language, level)
    },
    technologyLevelSummary(selection) {
      const total = selection.filter((item) => item.level).length

      if (total === 0) return 'Você pode selecionar mais de 1 opção'
      if (total === 1) return '1 selecionado'

      return `${total} selecionados`
    },
    selectedTechnologyLevelOptions(selection, options) {
      const optionValues = options.map((option) => option.value)

      return selection.filter((item) => {
        return item.level && optionValues.includes(item.technology)
      })
    },
    visibleTechnologyLevelOptions(selection, options) {
      return this.selectedTechnologyLevelOptions(selection, options)
    },
    technologyLevelChipText(selectionItem, options) {
      const option = options.find((item) => item.value === selectionItem.technology)
      const optionText = option ? option.text : selectionItem.technology
      const levelText = this.technologyLevelText(selectionItem.level)

      if (selectionItem.technology === 'other' && selectionItem.other) {
        return `${optionText} (${selectionItem.other}) - ${levelText}`
      }

      return `${optionText} - ${levelText}`
    },
    technologyLevelText(levelValue) {
      const level = this.technicalCompetencyLevels.find((item) => item.value === levelValue)

      return level ? level.text : levelValue
    },
    setTechnologyLevelSelection(selection, technology, level) {
      const selectedItem = selection.find((item) => item.technology === technology)

      if (selectedItem) {
        selectedItem.level = level
        return
      }

      selection.push({ technology, level, other: '' })
    },
    removeTechnologyLevelSelectionAt(selection, index) {
      const selectedItem = selection[index]
      if (!selectedItem) return

      selection.splice(index, 1)
      if (selectedItem.technology === 'other') this.clearTechnologyLevelOtherError(selection)
    },
    removeTechnologyLevelSelectionItem(selection, selectedItem) {
      const selectedItemIndex = selection.indexOf(selectedItem)
      if (selectedItemIndex < 0) return

      this.removeTechnologyLevelSelectionAt(selection, selectedItemIndex)
    },
    clearTechnologyLevelOtherError(selection) {
      if (selection === this.technicalCompetencies) {
        this.clearTechnicalOtherError('technical_competencies_other')
      } else if (selection === this.programmingLanguages) {
        this.clearTechnicalOtherError('programming_languages_other')
      } else if (selection === this.internalTechnologies) {
        this.clearTechnicalOtherError('internal_technologies_other')
      }
    },
    hasTechnicalOtherError(fieldName) {
      return Boolean(this.technicalOtherErrors[fieldName])
    },
    clearTechnicalOtherError(fieldName) {
      this.$delete(this.technicalOtherErrors, fieldName)
    },
    validateTechnicalCompetenciesForm(event) {
      if (event.submitter && event.submitter.dataset.skipProfileValidation) return

      const errors = {}

      if (!this.isBlank(this.technicalCompetencyOther)) {
        errors.technical_competencies_other = 'Selecione o grau de expertise para adicionar.'
      }

      if (!this.isBlank(this.programmingLanguageOther)) {
        errors.programming_languages_other = 'Selecione o grau de expertise para adicionar.'
      }

      if (!this.isBlank(this.internalTechnologyOther)) {
        errors.internal_technologies_other = 'Selecione o grau de expertise para adicionar.'
      }

      if (this.organizationalCertifications.includes('other') && this.isBlank(this.organizationalCertificationOther)) {
        errors.organizational_certifications_other = 'Informe qual certificação.'
      }

      this.technicalOtherErrors = errors

      if (!Object.keys(errors).length) return

      event.preventDefault()
      this.enableSubmitButtons(event.target)
      this.openFirstTechnicalOtherError(errors)
    },
    enableSubmitButtons(form) {
      this.$nextTick(() => {
        form.querySelectorAll('[type="submit"]').forEach((button) => {
          button.disabled = false
        })
      })
    },
    openFirstTechnicalOtherError(errors) {
      this.openModalDropdown = null
      this.$nextTick(() => {
        const firstInvalid = this.$el.querySelector('.is-invalid')
        if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    selectionSummary(selectedOptions) {
      const total = selectedOptions.length

      if (total === 0) return 'Selecione...'
      if (total === 1) return '1 selecionado'

      return `${total} selecionados`
    },
    blankProduct() {
      return {
        name: '',
        description: '',
        trl: '',
        uses_ia: null,
        ia_problem: '',
        ia_compliances: [],
        ia_market_segments: [],
        ia_market_segment_other: '',
        ia_types: [],
        ia_models: [],
        ia_providers: [],
        ia_provider_other: '',
        monetization_model: '',
        active_clients: '',
        has_intellectual_property: null,
        qty_patents: '',
        qty_trademarks: '',
        qty_software_registrations: ''
      }
    },
    blankCase() {
      return {
        title: '',
        description: '',
        solution: '',
        impact_project: null,
        approach: '',
        benefits: ''
      }
    },
    normalizeProduct(product) {
      const normalizedProduct = { ...this.blankProduct(), ...product }
      const arrayFields = ['ia_compliances', 'ia_market_segments', 'ia_types', 'ia_models', 'ia_providers', 'ia_infras']
      const stringFields = [
        'name',
        'description',
        'ia_problem',
        'ia_market_segment_other',
        'ia_provider_other',
        'monetization_model',
        'active_clients',
        'qty_patents',
        'qty_trademarks',
        'qty_software_registrations'
      ]

      arrayFields.forEach((field) => {
        normalizedProduct[field] = Array.isArray(normalizedProduct[field]) ? normalizedProduct[field] : []
      })

      stringFields.forEach((field) => {
        normalizedProduct[field] = normalizedProduct[field] === null || normalizedProduct[field] === undefined ? '' : String(normalizedProduct[field])
      })

      normalizedProduct.uses_ia = this.normalizeNullableBoolean(normalizedProduct.uses_ia)
      normalizedProduct.has_intellectual_property = this.normalizeNullableBoolean(normalizedProduct.has_intellectual_property)
      normalizedProduct.trl = normalizedProduct.trl ? String(normalizedProduct.trl) : ''

      return normalizedProduct
    },
    copyProduct(product) {
      const normalizedProduct = this.normalizeProduct(product)

      return {
        ...normalizedProduct,
        ia_compliances: [...normalizedProduct.ia_compliances],
        ia_market_segments: [...normalizedProduct.ia_market_segments],
        ia_types: [...normalizedProduct.ia_types],
        ia_models: [...normalizedProduct.ia_models],
        ia_providers: [...normalizedProduct.ia_providers],
        ia_infras: [...normalizedProduct.ia_infras]
      }
    },
    normalizeCase(projectCase) {
      const normalizedCase = { ...this.blankCase(), ...projectCase }
      const stringFields = ['title', 'description', 'solution', 'approach', 'benefits']

      stringFields.forEach((field) => {
        normalizedCase[field] = normalizedCase[field] === null || normalizedCase[field] === undefined ? '' : String(normalizedCase[field])
      })

      normalizedCase.impact_project = this.normalizeNullableBoolean(normalizedCase.impact_project)

      return normalizedCase
    },
    copyCase(projectCase) {
      return { ...this.normalizeCase(projectCase) }
    },
    productArrayField(fieldName) {
      const value = this.newProduct[fieldName]

      if (Array.isArray(value)) return value

      this.$set(this.newProduct, fieldName, [])
      return this.newProduct[fieldName]
    },
    companyArrayField(fieldName) {
      const value = this.company[fieldName]

      if (Array.isArray(value)) return value

      this.$set(this.company, fieldName, [])
      return this.company[fieldName]
    },
    isCompanyOptionSelected(fieldName, option) {
      return this.companyArrayField(fieldName).includes(option.value)
    },
    toggleCompanyOption(fieldName, option, event) {
      if (event.target.checked) {
        this.addCompanyOption(fieldName, option)
      } else {
        this.removeCompanyOption(fieldName, option)
      }
    },
    addCompanyOption(fieldName, option) {
      if (this.isCompanyOptionSelected(fieldName, option)) return

      this.companyArrayField(fieldName).push(option.value)
    },
    removeCompanyOption(fieldName, option) {
      this.company[fieldName] = this.companyArrayField(fieldName).filter((value) => value !== option.value)
    },
    selectedCompanyOptions(fieldName, options) {
      const selectedValues = this.companyArrayField(fieldName)

      return options.filter((option) => selectedValues.includes(option.value))
    },
    isModalOptionSelected(fieldName, option) {
      return this.productArrayField(fieldName).includes(option.value)
    },
    toggleModalOption(fieldName, option, event) {
      if (event.target.checked) {
        this.addModalOption(fieldName, option)
      } else {
        this.removeModalOption(fieldName, option)
      }
    },
    addModalOption(fieldName, option) {
      if (this.isModalOptionSelected(fieldName, option)) return

      this.productArrayField(fieldName).push(option.value)
    },
    isProductMarketSegmentDisabled(option) {
      return !this.isModalOptionSelected('ia_market_segments', option) &&
        this.productArrayField('ia_market_segments').length >= this.maxProductMarketSegments
    },
    addProductMarketSegment(option) {
      if (this.isModalOptionSelected('ia_market_segments', option)) return
      if (this.productArrayField('ia_market_segments').length >= this.maxProductMarketSegments) return

      this.productArrayField('ia_market_segments').push(option.value)
    },
    toggleProductMarketSegment(option, event) {
      if (event.target.checked) {
        this.addProductMarketSegment(option)
      } else {
        this.removeModalOption('ia_market_segments', option)
      }

      this.clearProductMarketSegmentOtherWhenNotSelected()
    },
    removeModalOption(fieldName, option) {
      this.newProduct[fieldName] = this.productArrayField(fieldName).filter((value) => value !== option.value)
      this.clearProductValidationError(fieldName)
      if (fieldName === 'ia_market_segments') this.clearProductMarketSegmentOtherWhenNotSelected()
      if (fieldName === 'ia_providers' && option.value === 'outros') this.clearProductValidationError('ia_provider_other')
    },
    selectedModalOptions(fieldName, options) {
      const selectedValues = this.productArrayField(fieldName)

      return options.filter((option) => selectedValues.includes(option.value))
    },
    isInnovationOptionSelected(fieldName, option) {
      return this.innovation[fieldName].includes(option.value)
    },
    toggleInnovationOption(fieldName, option, event) {
      if (event.target.checked) {
        this.addInnovationOption(fieldName, option)
      } else {
        this.removeInnovationOption(fieldName, option)
      }
    },
    addInnovationOption(fieldName, option) {
      if (this.isInnovationOptionSelected(fieldName, option)) return

      this.innovation[fieldName].push(option.value)
    },
    removeInnovationOption(fieldName, option) {
      this.innovation[fieldName] = this.innovation[fieldName].filter((value) => value !== option.value)
    },
    selectedInnovationOptions(fieldName, options) {
      return options.filter((option) => this.innovation[fieldName].includes(option.value))
    },
    filteredTypedPartnershipOptions(inputValue, options, fieldName) {
      const searchText = this.normalizeUniversityPartnershipText(inputValue)
      if (!searchText) return []

      return options.filter((option) => {
        const optionText = this.normalizeUniversityPartnershipText(option.text)
        const alreadySelected = this.innovation[fieldName].some((partnership) => {
          return this.normalizeUniversityPartnershipText(this.optionText(partnership, options)) === optionText
        })

        return optionText.includes(searchText) && !alreadySelected
      })
    },
    addTypedPartnership(fieldName, inputKey, suggestionsKey, options) {
      const partnership = String(this[inputKey] || '').trim()
      if (!partnership) return

      const alreadySelected = this.innovation[fieldName].some((selectedPartnership) => {
        return this.normalizeUniversityPartnershipText(this.optionText(selectedPartnership, options)) === this.normalizeUniversityPartnershipText(partnership)
      })

      if (!alreadySelected) {
        this.innovation[fieldName].push(partnership)
      }

      this[inputKey] = ''
      this[suggestionsKey] = false
    },
    selectTypedPartnershipSuggestion(fieldName, inputKey, suggestionsKey, options, option) {
      this[inputKey] = option.text
      this.addTypedPartnership(fieldName, inputKey, suggestionsKey, options)
    },
    removeTypedPartnership(fieldName, partnership) {
      this.innovation[fieldName] = this.innovation[fieldName].filter((selectedPartnership) => {
        return selectedPartnership !== partnership
      })
    },
    optionText(value, options) {
      const option = options.find((item) => item.value === value)

      return option ? option.text : value
    },
    openUniversityPartnershipSuggestions() {
      this.universityPartnershipSuggestionsOpen = true
    },
    addUniversityPartnership() {
      const partnership = String(this.universityPartnershipInput || '').trim()
      if (!partnership) return

      const alreadySelected = this.innovation.university_partnerships.some((selectedPartnership) => {
        return this.normalizeUniversityPartnershipText(this.universityPartnershipText(selectedPartnership)) === this.normalizeUniversityPartnershipText(partnership)
      })

      if (!alreadySelected) {
        this.innovation.university_partnerships.push(partnership)
      }

      this.universityPartnershipInput = ''
      this.universityPartnershipSuggestionsOpen = false
    },
    selectUniversityPartnershipSuggestion(option) {
      this.universityPartnershipInput = option.text
      this.addUniversityPartnership()
    },
    removeUniversityPartnership(partnership) {
      this.innovation.university_partnerships = this.innovation.university_partnerships.filter((selectedPartnership) => {
        return selectedPartnership !== partnership
      })
    },
    universityPartnershipText(partnership) {
      const option = this.universityPartnershipOptions.find((item) => item.value === partnership)

      return option ? option.text : partnership
    },
    normalizeUniversityPartnershipText(partnership) {
      return String(partnership || '').trim().toLowerCase()
    },
    openPartnershipUniversitiesSuggestions() {
      this.partnershipUniversitiesSuggestionsOpen = true
    },
    addPartnershipUniversity() {
      this.addTypedPartnership('partnership_universities_names', 'partnershipUniversitiesInput', 'partnershipUniversitiesSuggestionsOpen', this.shortUniversityOptions)
    },
    selectPartnershipUniversitySuggestion(option) {
      this.selectTypedPartnershipSuggestion('partnership_universities_names', 'partnershipUniversitiesInput', 'partnershipUniversitiesSuggestionsOpen', this.shortUniversityOptions, option)
    },
    removePartnershipUniversity(university) {
      this.removeTypedPartnership('partnership_universities_names', university)
    },
    partnershipUniversityText(university) {
      return this.optionText(university, this.shortUniversityOptions)
    },
    openPartnershipIctsSuggestions() {
      this.partnershipIctsSuggestionsOpen = true
    },
    addPartnershipIct() {
      this.addTypedPartnership('partnership_icts_names', 'partnershipIctsInput', 'partnershipIctsSuggestionsOpen', this.ictOptions)
    },
    selectPartnershipIctSuggestion(option) {
      this.selectTypedPartnershipSuggestion('partnership_icts_names', 'partnershipIctsInput', 'partnershipIctsSuggestionsOpen', this.ictOptions, option)
    },
    removePartnershipIct(ict) {
      this.removeTypedPartnership('partnership_icts_names', ict)
    },
    partnershipIctText(ict) {
      return this.optionText(ict, this.ictOptions)
    },
    addPartnershipBigPlayer() {
      const player = String(this.partnershipBigPlayersInput || '').trim()
      if (!player) return

      const alreadySelected = this.innovation.partnership_big_players_names.some((selectedPlayer) => {
        return this.normalizeUniversityPartnershipText(selectedPlayer) === this.normalizeUniversityPartnershipText(player)
      })

      if (!alreadySelected) {
        this.innovation.partnership_big_players_names.push(player)
      }

      this.partnershipBigPlayersInput = ''
    },
    removePartnershipBigPlayer(player) {
      this.innovation.partnership_big_players_names = this.innovation.partnership_big_players_names.filter((selectedPlayer) => {
        return selectedPlayer !== player
      })
    },
    isSelectionOptionSelected(selection, option) {
      return selection.includes(option.value)
    },
    toggleSelectionOption(selection, option, event) {
      if (event.target.checked) {
        this.addSelectionOption(selection, option)
      } else {
        this.removeSelectionOption(selection, option)
      }
    },
    addSelectionOption(selection, option) {
      if (this.isSelectionOptionSelected(selection, option)) return

      selection.push(option.value)
    },
    removeSelectionOption(selection, option) {
      const optionIndex = selection.indexOf(option.value)
      if (optionIndex < 0) return

      selection.splice(optionIndex, 1)
      if (option.value === 'other') {
        this.organizationalCertificationOther = ''
        this.clearTechnicalOtherError('organizational_certifications_other')
      }
    },
    selectedSelectionOptions(selection, options) {
      return options.filter((option) => selection.includes(option.value))
    },
    visibleSelectionOptions(selection, options) {
      return this.selectedSelectionOptions(selection, options)
    },
    selectedInnovationOptionsByPriority(fieldName, options) {
      return this.innovation[fieldName].map((value) => {
        return options.find((option) => option.value === value) || { value, text: value }
      })
    },
    innovationOptionPriority(fieldName, option) {
      const priorityIndex = this.innovation[fieldName].indexOf(option.value)

      return priorityIndex >= 0 ? priorityIndex + 1 : null
    },
    handleFormalPartnershipChange(partnershipType, value) {
      this.formalPartnerships[partnershipType] = this.normalizeBoolean(value)
      if (this.formalPartnerships[partnershipType]) return

      const fieldsByPartnershipType = {
        universities: ['partnership_universities_names'],
        icts: ['partnership_icts_names'],
        associatedCompanies: ['associated_company_suppliers', 'associated_company_clients'],
        bigPlayers: ['partnership_big_players_names'],
        internationalInstitutions: ['partnership_international_institution_names']
      }

      fieldsByPartnershipType[partnershipType].forEach((fieldName) => {
        this.innovation[fieldName] = []
      })

      if (partnershipType === 'associatedCompanies') {
        this.associatedCompanyRelationshipType = ''
      }

      this.openModalDropdown = null
    },
    setCurrentSubTab(tab) {
      this.currentSubTab = tab
      this.openModalDropdown = null

      if (!window.history || !window.URL) return

      const url = new URL(window.location.href)
      url.searchParams.set('tab', tab)
      window.history.replaceState({}, '', url.toString())
    },
    toggleModalDropdown(menuName) {
      this.openModalDropdown = this.openModalDropdown === menuName ? null : menuName
      this.activeTechnicalLevelOption = null
    },
    technicalLevelOptionKey(groupName, technology) {
      return `${groupName}:${technology}`
    },
    isTechnicalLevelOptionOpen(groupName, technology) {
      return this.activeTechnicalLevelOption === this.technicalLevelOptionKey(groupName, technology)
    },
    toggleTechnicalLevelOption(groupName, technology) {
      const optionKey = this.technicalLevelOptionKey(groupName, technology)
      this.activeTechnicalLevelOption = this.activeTechnicalLevelOption === optionKey ? null : optionKey

      if (technology === 'other' && this.activeTechnicalLevelOption === optionKey) {
        this.scrollToTechnicalLevelOther(groupName)
      }
    },
    scrollToTechnicalLevelOther(groupName) {
      this.$nextTick(() => {
        const submenu = this.$el.querySelector(`[data-technical-level-other="${groupName}"]`)
        if (!submenu) return

        submenu.scrollIntoView({ behavior: 'smooth', block: 'nearest' })

        const input = submenu.querySelector('input')
        if (input) input.focus()
      })
    },
    selectTechnologyLevelSelection(selection, technology, level) {
      this.setTechnologyLevelSelection(selection, technology, level)
      this.activeTechnicalLevelOption = null
      this.openModalDropdown = null
    },
    addTechnologyLevelOtherSelection(selection, groupName, level) {
      const inputName = this.technologyLevelOtherInputName(groupName)
      const errorName = this.technologyLevelOtherErrorName(groupName)
      const otherValue = String(this[inputName] || '').trim()

      if (!otherValue) {
        this.$set(this.technicalOtherErrors, errorName, this.technologyLevelOtherErrorMessage(groupName))
        return
      }

      selection.push({ technology: 'other', level, other: otherValue })
      this[inputName] = ''
      this.clearTechnicalOtherError(errorName)
    },
    technologyLevelOtherInputName(groupName) {
      const inputNames = {
        technicalCompetencies: 'technicalCompetencyOther',
        programmingLanguages: 'programmingLanguageOther',
        internalTechnologies: 'internalTechnologyOther'
      }

      return inputNames[groupName]
    },
    technologyLevelOtherErrorName(groupName) {
      const errorNames = {
        technicalCompetencies: 'technical_competencies_other',
        programmingLanguages: 'programming_languages_other',
        internalTechnologies: 'internal_technologies_other'
      }

      return errorNames[groupName]
    },
    technologyLevelOtherErrorMessage(groupName) {
      const errorMessages = {
        technicalCompetencies: 'Informe qual competência técnica.',
        programmingLanguages: 'Informe qual linguagem de programação.',
        internalTechnologies: 'Informe qual tecnologia interna.'
      }

      return errorMessages[groupName]
    },
    closeDropdownsOnOutsideClick(event) {
      if (
        !this.openModalDropdown &&
        !this.universityPartnershipSuggestionsOpen &&
        !this.partnershipUniversitiesSuggestionsOpen &&
        !this.partnershipIctsSuggestionsOpen
      ) return

      const targetElement = event.target.closest ? event.target : event.target.parentElement
      if (targetElement && targetElement.closest('.business-select-menu')) return

      this.openModalDropdown = null
      this.activeTechnicalLevelOption = null
      this.universityPartnershipSuggestionsOpen = false
      this.partnershipUniversitiesSuggestionsOpen = false
      this.partnershipIctsSuggestionsOpen = false
    },
    addProductToList() {
      if (this.editingProductIndex === null && this.productLimitReached) return
      this.clearIaProviderFieldsWhenThirdPartyModelIsNotSelected()
      if (!this.validateProductForm()) return

      const product = {
        ...this.newProduct,
        ia_compliances: [...this.productArrayField('ia_compliances')],
        ia_market_segments: [...this.productArrayField('ia_market_segments')],
        ia_market_segment_other: this.hasOtherProductMarketSegment ? this.newProduct.ia_market_segment_other : '',
        ia_types: [...this.productArrayField('ia_types')],
        ia_models: [...this.productArrayField('ia_models')],
        ia_providers: [...this.productArrayField('ia_providers')],
        ia_infras: [...this.productArrayField('ia_infras')]
      }

      if (this.editingProductIndex === null) {
        this.companyProducts.push(product)
      } else {
        this.companyProducts.splice(this.editingProductIndex, 1, {
          ...this.companyProducts[this.editingProductIndex],
          ...product
        })
      }

      this.resetProductForm()
      this.closeOwnProductsModal()
    },
    editProduct(index) {
      const product = this.companyProducts[index]
      if (!product) return

      this.hydratingProductForm = true
      this.editingProductIndex = index
      this.newProduct = this.copyProduct(product)
      this.openModalDropdown = null
      this.verDetalhesTRL = false
      this.$nextTick(() => {
        this.hydratingProductForm = false
      })
    },
    removeProduct(index) {
      const product = this.companyProducts[index]

      if (product && product.id) {
        this.removedProducts.push({ ...product, _destroy: true })
      }

      this.companyProducts.splice(index, 1)
    },
    resetProductForm() {
      this.hydratingProductForm = false
      this.newProduct = this.blankProduct()
      this.productValidationErrors = {}
      this.editingProductIndex = null
      this.openModalDropdown = null
      this.verDetalhesTRL = false
    },
    closeOwnProductsModal() {
      const modalElement = document.getElementById('ownProductsModal')
      if (!modalElement || !window.bootstrap) return

      const modal = window.bootstrap.Modal.getInstance(modalElement)
      if (modal) modal.hide()
    },
    clearIaProviderFieldsWhenThirdPartyModelIsNotSelected(iaModels = this.productArrayField('ia_models')) {
      if (Array.isArray(iaModels) && iaModels.includes('terceiros')) return

      this.newProduct.ia_providers = []
      this.newProduct.ia_provider_other = ''
      this.clearProductValidationError('ia_providers')
      this.clearProductValidationError('ia_provider_other')
      if (this.openModalDropdown === 'iaProvider') this.openModalDropdown = null
    },
    clearProductMarketSegmentOtherWhenNotSelected() {
      if (this.hasOtherProductMarketSegment) return

      this.newProduct.ia_market_segment_other = ''
      this.clearProductValidationError('ia_market_segment_other')
    },
    addCaseToList() {
      if (!this.newCase.title) return
      if (this.editingCaseIndex === null && this.caseLimitReached) return

      if (this.editingCaseIndex === null) {
        this.companyCases.push({ ...this.newCase })
      } else {
        this.companyCases.splice(this.editingCaseIndex, 1, {
          ...this.companyCases[this.editingCaseIndex],
          ...this.newCase
        })
      }

      this.resetCaseForm()
      this.closeCompanyCasesModal()
    },
    editCase(index) {
      const projectCase = this.companyCases[index]
      if (!projectCase) return

      this.editingCaseIndex = index
      this.newCase = this.copyCase(projectCase)
    },
    removeCase(index) {
      const projectCase = this.companyCases[index]

      if (projectCase && projectCase.id) {
        this.removedCases.push({ ...projectCase, _destroy: true })
      }

      this.companyCases.splice(index, 1)
    },
    resetCaseForm() {
      this.newCase = this.blankCase()
      this.editingCaseIndex = null
    },
    closeCompanyCasesModal() {
      const modalElement = document.getElementById('companyCasesModal')
      if (!modalElement || !window.bootstrap) return

      const modal = window.bootstrap.Modal.getInstance(modalElement)
      if (modal) modal.hide()
    },
    openModal(modalId) {
      const modalElement = document.getElementById(modalId)
      if (!modalElement || !window.bootstrap) return

      window.bootstrap.Modal.getOrCreateInstance(modalElement).show()
    }
  }
}
</script>
